import React from 'react';
import PropTypes from 'prop-types';

const DEFAULT_HEIGHT = {
  xsmall: '71',
  small: '92',
  medium: '173',
  large: '211',
};

const DEFAULT_WIDTH = {
  xsmall: '41',
  small: '78',
  medium: '64',
  large: '106',
};

function SlantedLine({
  fillClass,
  className,
  size,
  height,
  width,
}) {
  const finalHeight = height || DEFAULT_HEIGHT[size];
  const finalWidth = width || DEFAULT_WIDTH[size];

  if (size === 'xsmall') {
    return (
      <div className={className}>
        <svg aria-hidden="true" role="img" focusable="false" aria-label="" width={finalWidth} height={finalHeight} viewBox="0 0 41 71" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path className={fillClass} d="M36.7962 -2.40674L4.30469 101.085" stroke="#D23228" strokeWidth="7" strokeMiterlimit="10" />
        </svg>
      </div>
    );
  }

  if (size === 'small') {
    return (
      <div className={className}>
        <svg className="skew-forward" aria-hidden="true" role="img" focusable="false" aria-label="" width={finalWidth} height={finalHeight} viewBox="0 0 78 92" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path className={fillClass} d="M31 -154L31 317.34" strokeWidth="7" strokeMiterlimit="10" />
        </svg>
      </div>
    );
  }

  if (size === 'medium') {
    return (
      <div className={className}>
        <svg className="skew-forward" aria-hidden="true" role="img" focusable="false" aria-label="" width={finalWidth} height={finalHeight} viewBox="0 0 64 173" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path className={fillClass} d="M38 -13.5083L38 343.445" strokeWidth="7" strokeMiterlimit="10" />
        </svg>
      </div>
    );
  }

  if (size === 'large') {
    return (
      <div className={className}>
        <svg className="skew-forward" aria-hidden="true" role="img" focusable="false" aria-label="" width={finalWidth} height={finalHeight} viewBox="0 0 106 211" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path className={fillClass} d="M77 -19L77 452.34" strokeWidth="7" strokeMiterlimit="10" />
        </svg>
      </div>
    );
  }

  return null;
}

SlantedLine.propTypes = {
  fillClass: PropTypes.string,
  className: PropTypes.string.isRequired,
  size: PropTypes.string,
  width: PropTypes.any, // eslint-disable-line react/forbid-prop-types
  height: PropTypes.any, // eslint-disable-line react/forbid-prop-types
};

SlantedLine.defaultProps = {
  size: 'large',
  fillClass: 'edx-brand-fill',
  width: false,
  height: false,
};

export default SlantedLine;
